import { getCmsPlaceDetail } from "../../../app/api/getCmsPlaceDetail";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { IFamousPlace,IGetFamousPlaceActionParams,ICmsPlaceResponse } from "../../../Orchestrator/Types/Interface/ICmsDestination";


class GetCmsPlaceDetailAction extends BaseAction<IFamousPlace[], IGetFamousPlaceActionParams> {
  override async run(): Promise<IFamousPlace[] | null> {
    let listOfPlaces: IFamousPlace[] = [];
    try {
      const response: IApiResponse<ICmsPlaceResponse> = await getCmsPlaceDetail(this.params?.slug!);

      if (response.status === "ok" && response.answer) {
        const places = response.answer.data;
        if (places.length > 0) {
          listOfPlaces = places;
          updateRecoilState("cmsPLaceDetailAtom", listOfPlaces[0]);
        } else {
          updateRecoilState("cmsPLaceDetailAtom", null);
          console.warn("No places available.");
        }
      } else {
        console.warn("Failed to fetch places.");
      }
    } catch (error: any) {
      console.error("Error fetching places:", error);
    } finally {
      return listOfPlaces;
    }
  }
}

export const getCmsPlaceDetailAction = new GetCmsPlaceDetailAction();
